export default __webpack_public_path__ + "static/media/peephole.aadde463.gif";